module.exports = __webpack_public_path__ + "static/media/hero.94b9a136.png";